import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLocation } from 'react-router-dom';
import SwiperCore, { Navigation } from 'swiper';
import { isMobile } from 'react-device-detect';
import { getLocalStorage, isIosApp } from '../../../../common/common';
SwiperCore.use([Navigation]);
const cmeItemsArray = ['All CME', 'Upcoming', 'Reserved', 'Recorded'];

const CommonNavBarSection = ({ activeItem, tabItems, navItemSelector, onSubNavSelected }) => {
  const [distance, setDistance] = useState(null);
  const [eleHeight, setEleHeight] = useState(0);
  const [showTopClass, setShowTopClass] = useState(true);
  const { pathname } = useLocation();
  const pageName = pathname.slice(1);
  const [activeSlide, setActiveSlide] = useState(activeItem);
  const [activeCMESlide, setActiveCMESlide] = useState('All CME');
  const navItemHandler = (item) => {
    tabItems.includes(item) && setActiveSlide(item);
    navItemSelector(item.toLocaleLowerCase());
  };

  const onSubMenuItemClick = (item) => {
    setActiveCMESlide(item);
    onSubNavSelected(item.toLocaleLowerCase());
  };

  useEffect(() => {
    setActiveCMESlide(getLocalStorage('SelectedSubNavType', 'All CME'));
    return () => {
      setActiveCMESlide('All CME');
    };
  }, []);

  useEffect(() => {
    if (activeItem) {
      setActiveSlide(activeItem);
    }
    // return () => {
    //   setActiveSlide('');
    // };
  }, [activeItem]);

  const scrollListener = () => {
    if (document?.getElementById('headerDesktopNavBar')) {
      setEleHeight(document?.getElementById('headerDesktopNavBar').offsetHeight);

      const currentPosition = window.pageYOffset;
      if (document.getElementById('headerDesktopNavBar').offsetHeight >= currentPosition) {
        setShowTopClass(true);
      } else {
        setShowTopClass(false);
      }
    }

    var scrollTop = window?.scrollY || document?.documentElement?.scrollTop;
    if (document?.getElementById('my-element')) {
      var elementOffset =
        document?.getElementById('my-element')?.getBoundingClientRect()?.top + scrollTop;
      var distance = elementOffset - scrollTop;
      setDistance(distance);
    }

    // console.log("distance",distance)
  };

  useEffect(() => {
    document.addEventListener('scroll', scrollListener);
    return () => {
      document.removeEventListener('scroll', scrollListener);
    };
  }, []);

  return (
    <>
      <div
        id="my-element"
        className={`${
          !showTopClass ? 'rounded-top-0 mx-lg-n4' : 'mx-0'
        } rounded-4 mb-3 d-flex flex-column bg-white clr_v3_submenuTopbar position-sticky ${
          distance && distance < 0 && isIosApp() ? 'pt-50' : ''
        } transition`}
        style={{ zIndex: 1020, top: eleHeight - 1 }}
      >
        <div
          className="px-sm-4 px-3 w-100 position-relative z-1 clr_v3_Header__menuArea"
          id={'nav-item-speciality'}
        >
          <Swiper
            className="clr_v3_Header__menu fw-medium"
            loop={false}
            freeMode={true}
            spaceBetween={10}
            slidesPerView={'auto'}
            navigation={true}
          >
            {tabItems &&
              tabItems?.map((_i, _idx) => (
                <SwiperSlide
                  className="w-auto clr_v3_profileSubmenu"
                  key={_idx + 1}
                  onClick={() => navItemHandler(_i)}
                >
                  <a
                    id={`common_nav_bar_${_i.toLowerCase()}`}
                    href="javascript:void(0)"
                    className={`clr_v3_Header__menu__item my-sm-4 my-3 ${
                      _i.toLowerCase() == activeSlide.toLowerCase() ? 'active' : ''
                    }`}
                  >
                    {_i}
                    {_i == 'Certificate' && (
                      <span className="clr_v3_Header__menu__contentCount rounded-pill bg-primary text-white fs-6 px-2 py-1 position-absolute">
                        New
                      </span>
                    )}
                  </a>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
        {activeSlide == 'cme' && (
          <div className="px-sm-4 px-3 mb-3 w-100">
            <div className="fw-medium rounded-3 bg-light d-flex justify-content-around justify-content-sm-center clr_v3_Header__submenu">
              {cmeItemsArray &&
                cmeItemsArray?.map((_i, _idx) => (
                  <a
                    href="javascript:void(0)"
                    key={_idx + 1}
                    onClick={() => onSubMenuItemClick(_i)}
                    className={`clr_v3_Header__menu__item ${
                      _i.toLocaleLowerCase() == activeCMESlide.toLocaleLowerCase() ? 'active' : ''
                    }`}
                  >
                    {_i}
                  </a>
                ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CommonNavBarSection;
